import { Star, Quote } from "lucide-react";
import { TESTIMONIALS, CLINIC } from "@/lib/clinic";

export default function Testimonials() {
  // duplicate for seamless marquee
  const items = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <section id="reviews" data-testid="section-reviews" className="py-20 md:py-28 bg-white overflow-hidden">
      <div className="container-x">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div className="max-w-xl">
            <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#2D4A3E] font-medium">
              What patients say
            </span>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1C221F] tracking-tight">
              {CLINIC.rating}★ from {CLINIC.reviewCount}+ Google reviews.
            </h2>
          </div>
          <a
            href="https://www.google.com/search?q=City+Smiles+Dental+Clinic+Ratia+reviews"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="link-google-reviews"
            className="text-sm text-[#2D4A3E] font-medium hover:underline underline-offset-4"
          >
            Read all reviews on Google →
          </a>
        </div>
      </div>

      <div className="mt-12 relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="flex gap-5 marquee w-max">
          {items.map((t, i) => (
            <article
              key={`${t.name}-${i}`}
              data-testid={`testimonial-${i}`}
              className="w-[320px] sm:w-[380px] shrink-0 bg-[#FAFAF9] border border-stone-200 rounded-2xl p-6 soft-shadow"
            >
              <Quote className="w-6 h-6 text-[#D4B27E]" strokeWidth={1.5} />
              <div className="mt-3 flex items-center gap-0.5 text-[#F59E0B]">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-current" strokeWidth={0} />
                ))}
              </div>
              <p className="mt-4 text-[#1C221F]/85 leading-relaxed text-sm sm:text-base">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#2D4A3E]/10 text-[#2D4A3E] flex items-center justify-center font-display font-semibold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-medium text-[#1C221F]">{t.name}</div>
                  <div className="text-xs text-[#57605B]">{t.location}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
